import React from 'react';
import { ExternalLink } from 'lucide-react';
import { useAdSurfaceAndSlot } from '../../hooks/useAdSurfaceAndSlot';
import { isValidAdDestination } from '../../utils/adDestinationUrl';
import { Root, Img, Body, Top, Sponsored, Sponsor, H, Desc, Cta } from './AdSidebar.styled';

/** Sponsored card with image + copy. Works with static assets or managed campaign-mapped `ad` objects. */
export default function AdSidebar({ ad, pageKey, onLinkClick }) {
  const { loaded, slotVisible } = useAdSurfaceAndSlot(pageKey);
  if (!loaded || !slotVisible || !ad?.image) return null;

  const dest = isValidAdDestination(ad.url);
  const href = dest ? ad.url : '#';
  const onClick = (e) => {
    if (!dest) e.preventDefault();
    else onLinkClick?.(e);
  };

  return (
    <Root
      href={href}
      onClick={onClick}
      target={dest ? '_blank' : undefined}
      rel={dest ? 'noopener noreferrer sponsored' : undefined}
    >
      <Img src={ad.image} alt={ad.title} loading="lazy" decoding="async" />
      <Body>
        <Top>
          <Sponsored>Sponsored</Sponsored>
          <Sponsor>{ad.sponsor}</Sponsor>
        </Top>
        <H>{ad.title}</H>
        <Desc>{ad.description}</Desc>
        <Cta>
          {ad.cta} <ExternalLink size={10} />
        </Cta>
      </Body>
    </Root>
  );
}
